const progress = {
  childCoinsInformation: (childId) => `/child/${childId}/getPointCount/`,
};

const avatar = {
  AvatarBankPath: '/profile_avatar/',
  AvatarSelectionPath: (childId) => `/child/${childId}/avatar_setup/`,
};

const ranking = {
  RankingInfoPath: (childId) => `/ranking/?count=10&user=${childId}`,
};

const rewards = {
  newReward: `/rewards/`,
  defaultRewards: `/rewards/prepopulated/`,
  rewards: (childId) => `/child/${childId}/getRewards/`,
  updateReward: (rewardId) => `/rewards/${rewardId}/`,
  claimReward: (rewardId) => `/rewards/${rewardId}/claim/`,
};

const badges = {
  lockedBadges: (childId) => `/child/${childId}/locked_badges/`,
  unlockedBadges: (childId) => `/child/${childId}/unlocked_badges/`,
};

const rate = {
  rate: `/rate/`,
  questions: `/rate/getQuestions/`,
  weekAnswers: (childId) => `/rate/${childId}/getThisWeekAnswers/`,
};

const coinsUpdater = {
  coinsValues: (childId) => `/child/${childId}/getCoinsValues/`,
  saveCoinsValues: (childId) => `/child/${childId}/setCoinsValues/`,
};

const coinsApproved = {
  childCoinsPending: (childId) => `/child/${childId}/getCoinsPending/`,
  acceptOrRejectCoins: (itemId) => `/point/${itemId}/activate/`,
};

export { progress, avatar, ranking, rewards, badges, coinsUpdater, rate, coinsApproved };
